import { render, staticRenderFns } from "./VocabAudio.vue?vue&type=template&id=56c5ba70&scoped=true"
import script from "./VocabAudio.vue?vue&type=script&lang=js"
export * from "./VocabAudio.vue?vue&type=script&lang=js"
import style0 from "./VocabAudio.vue?vue&type=style&index=0&id=56c5ba70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5ba70",
  null
  
)

export default component.exports